"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableCellMixin = void 0;
/** @class TableCellMixin */
/** @method */
var TableCellMixin = function TableCellMixin(_ref) {
  var align = _ref.align;
  return "\n    /* Increase specificity in order to override styles added later on by the\n    alignments prop in TableMixin. Ex:\n    .kUmSyA .TableCell__StyledTableCell-sc-1mvjdio-0:nth-child(1) */\n    &&&& {\n        text-align: " + (align || '') + ";\n    }\n";
};
exports.TableCellMixin = TableCellMixin;